<div [formGroup]="formGroup">
  <sc-string-field labelDictionaryKey="tmc-yard.entity.transport.masterdata.carrier" formControlName="name"></sc-string-field>
</div>
